module.exports = __webpack_public_path__ + "static/arbutus-logo-a6fc6d8949c1963368a401219efa13b3.jpeg";